/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreHistoryManagementShowOrderResponse } from './StoreHistoryManagementShowOrderResponse';

export type StoreHistoryManagementShowOrderResponseApiRespoonse = {
    data?: StoreHistoryManagementShowOrderResponse;
    status?: StoreHistoryManagementShowOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreHistoryManagementShowOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

